let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4KF6S")).then(() => parcelRequire('hPioD'));